<template>
    <a-drawer placement="right" :closable="false" :visible="showDetail" @close="close" width="70%">
        <div class="header">
            {{ attendDate }}运营详情
            <a class="close" @click="close">
                <img src="../../../../public/close.png" />
            </a>
        </div>
        <div class="nav">
            <div class="class-count">
                <div class="pic">
                    <img src="../../../../public/operation/class.png">
                </div>
                <div>
                    <p><b>{{ classInfo.totalClassCount }}</b></p>
                    <span>班级数</span>
                </div>
                <div class="border"></div>
                <div class="df1">
                    <div>
                        <p>{{ classInfo.trustClassCount }}</p>
                        <span>托管班</span>
                    </div>
                    <div>
                        <p>{{ classInfo.corClassCount }}</p>
                        <span>社团班</span>
                    </div>
                    <div>
                        <p>{{ classInfo.perClassCount }}</p>
                        <span>特色班</span>
                    </div>
                </div>
            </div>
            <div class="class-count" style="width: 55%;">
                <div class="pic">
                    <img src="../../../../public/operation/student.png">
                </div>
                <div>
                    <p><b>{{ studentInfo.totalStudent }}</b></p>
                    <span>参与学员数</span>
                </div>
                <div class="border"></div>
                <div class="df1">
                    <div>
                        <p>{{ studentInfo.trustStudentCount }}</p>
                        <span>托管班</span>
                    </div>
                    <div>
                        <p>{{ studentInfo.corStudentCount }}</p>
                        <span>社团班</span>
                    </div>
                    <div>
                        <p>{{ studentInfo.perStudentCount }}</p>
                        <span>特色班</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="avatar">
            <div class="teacher-item" v-for="(item, index) in teacherInfo" :key="index">
                <img :src="item.imgUrl ? item.imgUrl : 'https://static.khsdb.com/operation/images/seat.png'">
                <div class="teacher">
                    <div class="name">{{ item.operUserName }}</div>
                    <p>{{ item.isManager ? '运营主管' : '驻校运营' }}</p>
                    <p>
                        <span v-if="item.checkinStatus !== 0">已在{{ item.checkTime }}签到&nbsp;&nbsp;</span>
                        <span v-if="item.checkinStatus == 1" class="ok">(正常签到)</span>
                        <span v-if="item.checkinStatus == -1" class="err">
                            (异常：{{ item.subStatus.includes('2') ? '补签' : '' }}
                            {{ item.subStatus.includes(',') ? '/' : '' }}
                            {{ item.subStatus.includes('3') ? '地点异常' : '' }})
                        </span>
                        <span v-if="item.checkinStatus == 0" class="err">未签到</span>
                        <!-- 签退信息 -->
                        <template v-if="item.needCheckout == 1 || item.isManager">，
                            <span v-if="!item.checkoutStatus" class="err">未签退</span>
                            <span v-else>
                                <span v-if="item.checkoutStatus !== 0">
                                    已在{{ item.checkoutTime }}签退&nbsp;&nbsp;</span>
                                <span v-if="item.checkoutStatus == 1" class="ok">(正常签退)</span>
                                <span v-if="item.checkoutStatus == -1" class="err">
                                    (异常：{{ item.subCheckoutStatus.includes('0') ? '早退' : '' }}
                                    {{ item.subCheckoutStatus.includes('2') ? '补签' : '' }}
                                    {{ item.subCheckoutStatus.includes(',') ? '/' : '' }}
                                    {{ item.subCheckoutStatus.includes('3') ? '地点异常' : '' }})
                                </span>
                            </span>
                        </template>
                    </p>
                </div>
            </div>
        </div>
        <h3>班级情况汇总</h3>
        <a-table :columns="columns" :data-source="listData" bordered style="margin: 0 25px 32px;" :pagination="false"
            :loading="loading" :rowKey="getRowKey">
            <span slot="className" slot-scope="text,record">
                <a-popover>
                    <template slot="content">
                        <p>{{ text }},{{ record.classTime }}</p>
                    </template>
                    <span class="ellipsis">
                        {{ text }}
                    </span>
                </a-popover>
            </span>
            <span slot="courseName" slot-scope="text">
                <a-popover>
                    <template slot="content">
                        <p>{{ text }}</p>
                    </template>
                    <span class="ellipsis">
                        {{ text }}
                    </span>
                </a-popover>
            </span>
            <span slot="lectureTeacher" slot-scope="text,record">
                <template>
                    <a-popover>
                        <template slot="content">
                            <div v-if="record.checkinStatus && record.checkinStatus !== 0">
                                <p>已在{{ record.lectureCheckinTime }}{{ record.checkinStatus == -1 ? '异常签到' :
                                    record.checkinStatus == 1 ? '签到' : record.checkinStatus == 2 ? '请假' : '' }}
                                </p>
                            </div>
                            <div v-else>未签到</div>
                        </template>
                        <div style="min-width: 80px;" v-if="text">
                            {{ text }}
                            <a-icon v-if="record.checkinStatus == -1 || record.checkinStatus == 2" type="close-circle"
                                style="color: #FF0000;" />
                            <a-icon v-if="record.checkinStatus == 0" type="exclamation-circle"
                                style="color: #FF9200;" />
                            <a-icon v-if="record.checkinStatus == 1" type="check-circle" style="color: #10B45A;" />
                        </div>
                    </a-popover>
                </template>
            </span>
            <span slot="assistantTeacherCheckinDTOList" slot-scope="text">
                <template>
                    <a-popover>
                        <template slot="content">
                            <div>
                                <div v-for="(item, index) in text" :key="index">
                                    <span>{{ item.teacherName }}</span>在{{ item.checkinTime }}<span
                                        v-if="item.checkinStatus == -1">异常签到</span><span
                                        v-if="item.checkinStatus == 1">签到</span><span
                                        v-if="item.checkinStatus == 2">请假</span>
                                </div>
                            </div>
                        </template>
                        <div class="ellipsis">
                            <span v-for="(item, index) in text" :key="index">
                                {{ item.teacherName }}
                                <a-icon v-if="item.checkinStatus == -1" type="close-circle" style="color: #FF0000;" />
                                <a-icon v-if="item.checkinStatus == 1" type="check-circle" style="color: #10B45A;" />
                                <a-icon v-if="item.checkinStatus == 2" type="exclamation-circle"
                                    style="color: #FF9200;" />
                            </span>
                        </div>
                    </a-popover>
                </template>
            </span>
            <span slot="type1" slot-scope="text">
                <span :class="{ 'gray': text == 0 || text == null, 'err': text == 2 }">
                    {{ text == 1 ? '正常' : text == 2 ? '异常' : '未登记' }}
                </span>
            </span>
            <span slot="type2" slot-scope="text,record">
                <div :class="{ 'gray': text == 0 || text == null, 'err': text == 2 }">
                    <a-popover>
                        <template slot="content">
                            <p>已出勤{{ record.studentCountAttend }}人，应出勤{{ record.studentCount }}人</p>
                        </template>
                        <span class="ellipsis">
                            <span style="color: #171A1D99;">{{ record.studentCountAttend }}/{{
                                record.studentCount }}</span>
                            {{ text == 1 ? '正常' : text == 2 ? '异常' : '未登记' }}
                        </span>
                    </a-popover>
                </div>
            </span>
            <span slot="type3" slot-scope="text">
                <span
                    :class="{ 'gray': text == 0 || text == null, 'ok': text == 1, 'general': text == 2, 'err': text == 3 }">
                    {{ text == 1 ? '良好' : text == 2 ? '一般' : text == 3 ? '差' : '未登记' }}
                </span>
            </span>
            <span slot="type4" slot-scope="text">
                <span
                    :class="{ 'gray': text == 0 || text == null, 'ok': text == 1, 'general': text == 2, 'err': text == 3 }">
                    {{ text == 1 ? '良好' : text == 2 ? '一般' : text == 3 ? '差' : '未登记' }}
                </span>
            </span>
            <span slot="type5" slot-scope="text">
                <span
                    :class="{ 'gray': text == 0 || text == null, 'ok': text == 1, 'general': text == 2, 'err': text == 3 }">
                    {{ text == 1 ? '良好' : text == 2 ? '一般' : text == 3 ? '差' : '未登记' }}
                </span>
            </span>
            <span slot="type6" slot-scope="text">
                <span
                    :class="{ 'gray': text == 0 || text == null, 'ok': text == 1, 'general': text == 2, 'err': text == 3 }">
                    {{ text == 1 ? '良好' : text == 2 ? '一般' : text == 3 ? '差' : '未登记' }}
                </span>
            </span>
        </a-table>
        <h3>当日运营总结</h3>
        <div class="mh210">
            <div class="summary">
                <div class="status">
                    <div class="pic">
                        <img v-if="summaryInfo.status == '1'" src="../../../../public/operation/good.png" alt="">
                        <img v-if="summaryInfo.status == '2'" src="../../../../public/operation/general.png" alt="">
                        <img v-if="summaryInfo.status == '3'" src="../../../../public/operation/bad.png" alt="">
                    </div>
                    <div class="text">
                        <b>
                            {{ summaryInfo.status == '1' ? '良好' : summaryInfo.status == '2' ? '一般' : summaryInfo.status
                                == '3' ? '差' : '未选择' }}
                        </b>
                        <p>整体表现</p>
                    </div>
                    <div class="contetn"><img src="../../../../public/operation/bg.png" alt="">{{ summaryInfo.content ||
                        '暂未总结' }}</div>
                </div>
                <div class="qrcode" v-if="qrcodeImg">
                    <img :src="qrcodeImg" alt="">
                    <p>扫码查看运营报告</p>
                </div>
            </div>
            <div class="backImg">
                <div class="pic" v-for="(item, index) in summaryInfo.imgs" :key="index">
                    <a @click="previewImg(item)"><img :src="item"></a>
                </div>
            </div>
        </div>
        <div v-if="listData2 && listData2.length">
            <h3>基础课后服务自主考勤</h3>
            <div>
                <a-table :columns="columns2" :data-source="listData2" bordered style="margin: 0 25px 32px;"
                    :pagination="false" :rowKey="getRowKey">
                    <span slot="status" slot-scope="text,record">
                        <span class="ok" v-if="text == 1">正常签到</span>
                        <a-popover v-else>
                            <template slot="content">
                                <p>异常原因：{{ record.substatusText }}</p>
                            </template>
                            <span class="general">异常签到</span>
                        </a-popover>
                    </span>
                </a-table>
            </div>
        </div>
        <div class="mask" @click="closePreview" v-if="previewPic" @mousewheel.prevent="rollImg">
            <div ref="imgDiv">
                <img :src="imageSrc" ref="image" @mousedown="move" />
            </div>
        </div>
    </a-drawer>
</template>

<script>
import QRCode from 'qrcode';
import operation from "../../../api/operation";
import dayjs from "dayjs";
const columns = [
    {
        title: '班级名称',
        dataIndex: 'className',
        scopedSlots: { customRender: 'className' },
    },
    {
        title: '课程名称',
        dataIndex: 'courseName',
        scopedSlots: { customRender: 'courseName' },
    },
    {
        title: '主讲老师',
        dataIndex: 'lectureTeacher',
        scopedSlots: { customRender: 'lectureTeacher' },
    },
    {
        title: '助教老师',
        dataIndex: 'assistantTeacherCheckinDTOList',
        scopedSlots: { customRender: 'assistantTeacherCheckinDTOList' },
    },
    {
        title: '老师考勤',
        dataIndex: 'type1',
        scopedSlots: { customRender: 'type1' },
        width: 95,
    },
    {
        title: '学生出勤',
        dataIndex: 'type2',
        scopedSlots: { customRender: 'type2' },
        width: 125,
    },
    {
        title: '课堂纪律',
        dataIndex: 'type3',
        scopedSlots: { customRender: 'type3' },
        width: 95,
    },
    {
        title: '卫生情况',
        dataIndex: 'type4',
        scopedSlots: { customRender: 'type4' },
        width: 95,
    },
    {
        title: '离校情况',
        dataIndex: 'type5',
        scopedSlots: { customRender: 'type5' },
        width: 95,
    },
    {
        title: '班级群反馈',
        dataIndex: 'type6',
        scopedSlots: { customRender: 'type6' },
        width: 110,
    },
]
const columns2 = [
    {
        title: '考勤时间',
        dataIndex: 'checkinTime',
        width: 180,
    },
    {
        title: '姓名',
        dataIndex: 'teacherName',
    },
    {
        title: '考勤状态',
        dataIndex: 'status',
        scopedSlots: { customRender: 'status' },
    },
    {
        title: '上课时间',
        dataIndex: 'classTime',
        scopedSlots: { customRender: 'classTime' },
        width: 120,
    },
    {
        title: '班级',
        dataIndex: 'originalClassName'
    },
]
export default {
    data() {
        return {
            columns,
            columns2,
            listData: [],
            listData2: [],
            qrcodeImg: '',
            loading: true,
            teacherInfo: {},
            summaryInfo: {},
            classInfo: {},
            studentInfo: {},

            previewPic: false,
        }
    },
    props: {
        showDetail: {
            type: Boolean,
            default: false,
        },
        attendDate: {
            type: String,
        },
    },
    created() {
        this.getData()
    },
    methods: {
        getRowKey(record, index) {
            return index;
        },
        getData() {
            let params = { attendDate: this.attendDate, schoolId: this.$ls.get('schoolId') }
            operation.operationSchedulingReport(params).then(res => {
                this.teacherInfo = res.data.operSchedulingCheckDTO
                if (res.data.operSupervisorCheckDTO) {
                    res.data.operSupervisorCheckDTO.forEach(item => {
                        this.teacherInfo.push({ ...item, isManager: true })
                    })
                }
                this.teacherInfo.forEach(item => {
                    item.checkTime = dayjs(item.checkinTime).format('HH:mm')
                    item.checkoutTime = dayjs(item.checkoutTime).format('HH:mm')
                })
                this.listData = res.data.operSchedulingClassOverviewDTOList
                this.listData2 = res.data.teacherIndependentAttendanceCheckinDTOList || []
                this.listData2.forEach(item => {
                    if (item.substatus) {
                        let temp = item.substatus.split(',')
                        item.substatusText = (temp.includes('1') ? '迟到' : '') + (temp.includes('2') ? '补卡' : '') + (temp.length == 2 ? ',' : '') + (temp.includes('3') ? '地点异常' : '')
                    }
                })
                this.classInfo = res.data.scheduleOperClassCountDTO
                this.studentInfo.totalStudent = res.data.scheduleOperStudentCountDTO ? res.data.scheduleOperStudentCountDTO.totalStudent.toLocaleString('en-US') : 0
                this.studentInfo.corStudentCount = res.data.scheduleOperStudentCountDTO ? res.data.scheduleOperStudentCountDTO.corStudentCount.toLocaleString('en-US') : 0
                this.studentInfo.perStudentCount = res.data.scheduleOperStudentCountDTO ? res.data.scheduleOperStudentCountDTO.perStudentCount.toLocaleString('en-US') : 0
                this.studentInfo.trustStudentCount = res.data.scheduleOperStudentCountDTO ? res.data.scheduleOperStudentCountDTO.trustStudentCount.toLocaleString('en-US') : 0
                res.data.operSchedulingSummarizeDTOList.forEach(item => {
                    if (item.contentType == 1) {
                        this.summaryInfo.content = item.content
                    } else if (item.contentType == 2) {
                        this.summaryInfo.imgs = item.content.split(',')
                    } else {
                        this.summaryInfo.status = item.content
                    }
                })
                if (res.data.shortLink) this.getQrCode(res.data.shortLink)
                this.handleData()
                this.loading = false
            }).catch(err => {
                setTimeout(() => {
                    this.close()
                }, 600);
            })
        },
        handleData() {
            this.listData.forEach(item => {
                if (item.lectureCheckinTime) item.lectureCheckinTime = dayjs(item.lectureCheckinTime).format('HH:mm')
                if (item.assistantTeacherCheckinDTOList) {
                    item.assistantTeacherCheckinDTOList.forEach(item2 => {
                        item2.checkinTime = dayjs(item2.checkinTime).format('HH:mm')
                    })
                }
                if (item.operSchedulingClassCheckDOList) {
                    item.operSchedulingClassCheckDOList.forEach(item2 => {
                        if (item2.checkType == 1) item.type1 = item2.checkValue
                        if (item2.checkType == 2) item.type2 = item2.checkValue
                        if (item2.checkType == 3) item.type3 = item2.checkValue
                        if (item2.checkType == 4) item.type4 = item2.checkValue
                        if (item2.checkType == 5) item.type5 = item2.checkValue
                        if (item2.checkType == 6) item.type6 = item2.checkValue
                    })
                }
            })
        },
        getQrCode(url) {
            QRCode.toDataURL(url, { margin: 0 }).then(res => {
                this.qrcodeImg = res
            })
        },
        close() {
            this.$emit("update:showDetail", false);
        },
        previewImg(item) {
            this.previewPic = true
            this.imageSrc = item
        },
        closePreview() {
            this.imageSrc = ''
            this.previewPic = false
        },
        rollImg() {
            var zoom = parseInt(this.$refs.imgDiv.style.zoom) || 100
            zoom += event.wheelDelta / 12
            if (zoom >= 70 && zoom < 500) {
                this.$refs.imgDiv.style.zoom = zoom + '%'
            }
            return false
        },
        move(e) {
            e.preventDefault()
            var left = document.querySelector('.left')
            var img = document.querySelector('.img')
            var x = e.pageX - img.offsetLeft
            var y = e.pageY - img.offsetTop
            left.addEventListener('mousemove', move)
            function move(e) {
                img.style.left = e.pageX - x + 'px'
                img.style.top = e.pageY - y + 'px'
            }
            img.addEventListener('mouseup', function () {
                left.removeEventListener('mousemove', move)
            })
            left.addEventListener('mouseout', function () {
                left.removeEventListener('mousemove', move)
            })
        },
    },

}
</script>

<style lang="less" scoped>
::v-deep .ant-drawer-body {
    padding: 0;
    font-family: PingFangSC, PingFang SC;
}

.header {
    position: relative;
    padding: 26px 25px 21px;
    font-weight: 600;
    font-size: 16px;
    color: #1B1D26;
    line-height: 22px;
    line-height: 22px;
    border-bottom: 4px solid #F1F6FC;

    .close {
        position: absolute;
        top: 20px;
        right: 25px;
    }
}

.nav {
    padding: 24px 25px;
    border-bottom: 1px solid rgba(126, 134, 142, 0.16);
    display: flex;

    .class-count {
        width: 45%;
        display: flex;

        .pic {
            width: 70px;
            height: 70px;
            margin-right: 20px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .border {
            width: 2px;
            height: 66px;
            background: #F0F2F5;
            margin: 0 25px;
        }

        p {
            font-size: 20px;
            color: #35383E;
            line-height: 22px;
            padding-top: 6px;
            margin-bottom: 5px;
        }

        b {
            margin: 1px 0 5px;
            display: block;
            font-size: 30px;
            color: #35383E;
        }

        span {
            padding-top: 5px;
            display: block;
            font-size: 14px;
            color: #35383E;
            line-height: 22px;
        }

        .df1 {
            flex: 0.8;
            display: flex;
            justify-content: space-around;
        }
    }

}

.avatar {
    padding: 25px 0 12px 25px;
    display: flex;
    flex-wrap: wrap;
    color: #35383E;

    .teacher-item {
        display: flex;
        width: 50%;
        margin-bottom: 20px;
    }

    img {
        width: 70px;
        height: 70px;
        border-radius: 35px;
        margin-right: 12px;
    }

    .name {
        font-weight: bold;
        margin-bottom: 4px;
        font-size: 16px;
        line-height: 22px;
    }

}

.gray {
    color: #bfbfbf;
}

.ok {
    color: #10B45A;
}

.err {
    color: #FF0000;
}

.general {
    color: #FF9200;
}

h3 {
    font-weight: 600;
    font-size: 20px;
    color: #35383E;
    line-height: 22px;
    margin-bottom: 17px;
    padding-left: 25px;
}

::v-deep .ant-table-thead th {
    color: rgba(23, 26, 29, 0.6);
    line-height: 14px !important;
    padding: 12px 19px !important;
}

::v-deep .ant-table-tbody td {
    color: #35383E;
    height: 16px;
    padding: 8px 19px !important;
}

.summary {
    padding: 6px 25px;
    position: relative;

    .status {
        display: flex;
        margin-right: 335px;
        flex: 1;

        .pic {
            width: 85px;

            img {
                display: block;
                margin: 0 auto;
            }
        }

        b {
            font-weight: 600;
            font-size: 20px !important;
            line-height: 22px;
            margin: 10px 0 7px;
            display: block;
        }

        .text {
            color: #35383E;
            margin: 0 24px 0 20px;
        }

        p {
            font-size: 14px;
            line-height: 22px;
        }

        .contetn {
            position: relative;
            background: #F6F9FD;
            margin-left: 24px;
            padding: 24px 16px;
            flex: 1;
            min-width: 200px;
            white-space: pre-wrap;

            img {
                position: absolute;
                top: 13px;
                left: 18px;
            }
        }
    }

    .qrcode {
        position: absolute;
        top: 0;
        right: 25px;
        background: #F6F9FD;
        padding: 24px 24px 16px;

        img {
            width: 140px;
            height: 140px;
            display: block;
            margin-bottom: 16px;
        }

        p {
            text-align: center;
            font-size: 14px;
            color: #35383E;
            line-height: 22px;
        }
    }
}

.ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    text-overflow: ellipsis;
    overflow: hidden;
}

.backImg {
    display: flex;
    padding-left: 234px;
    margin: 12px 0 24px;

    .pic {
        margin-right: 12px;

        img {
            width: 70px;
            height: 70px;
            border-radius: 4px;
        }
    }
}

.mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 25px;
    overflow: hidden;

    img {
        max-height: 100vh;
    }
}

.mh210 {
    min-height: 210px;
}
</style>